import React, { useState } from 'react';
import './FilterTicketModal.css';

interface SearchTicketModalProps {
    isVisible: boolean;
    onClose: () => void;
    onSearch: (ticketData: any) => void;
    clients: any[];
    services: any[];
    states: any[];
}

const FilterTicketModal: React.FC<SearchTicketModalProps> = ({ isVisible, onClose, onSearch, clients, services, states }) => {
    const [selectedClientId, setSelectedClientId] = useState(''); // Track the selected clientId
    const [selectedClientPlants, setSelectedClientPlants] = useState<string[]>([]); // Track plants for the client
    const [selectedPlant, setSelectedPlant] = useState('');
    const [selectedState, setSelectedState] = useState('');
    const [selectedService, setSelectedService] = useState('');

    const handleSearchClick = async () => {
        const filters = {
            clientId: selectedClientId,
            plantId: selectedPlant,
            state: selectedState,
            service: selectedService
        }
        onSearch(filters);
        onClose()
    };

    const handleClientChange = (clientId: string) => {
        setSelectedClientId(clientId); // Update the selected client by id
        const clientData: any = clients.find((client: any) => client.clientId.toString() === clientId);
        setSelectedClientPlants(clientData?.plants || []);
        setSelectedPlant(''); // Reset the selected plant
    };

    const handleClearFilters = () => {
        setSelectedClientId('');
        setSelectedClientPlants([]);
        setSelectedPlant('');
        setSelectedState('');
        setSelectedService('');
    };

    if (!isVisible) {
        return null;
    }

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="top">
                    <div className="search">
                        <span className="material-icons-outlined search-icon">search</span>
                        <p className="buscar-header">FILTRAR</p>
                    </div>
                    <div className="close-button" onClick={onClose}>
                        <span className="material-icons-outlined close-icon">close</span>
                    </div>
                </div>
                <div className="body-filter-ticket">
                    <div className="body-filter-dropdown">
                        <select
                            id="cliente"
                            value={selectedClientId}
                            onChange={(e) => handleClientChange(e.target.value)}
                            className="dropdown"
                        >
                            <option value="">CLIENTE</option>
                            {clients?.map((client: any) => (
                                <option key={client.clientId} value={client.clientId}>
                                    {client.clientName}
                                </option>
                            ))}
                        </select>

                        <select
                            id="planta"
                            value={selectedPlant}
                            onChange={(e) => setSelectedPlant(e.target.value)}
                            disabled={!selectedClientId}
                            className="dropdown"
                        >
                            <option value="" disabled={!selectedClientId}>
                                {selectedClientId ? 'PLANTA' : 'Seleccione una planta'}
                            </option>
                            {selectedClientPlants.map((plant:any, index) => (
                                <option key={plant.plantId} value={plant.plantId}>
                                    {plant.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="body-filter-dropdown">
                        <select
                            value={selectedState}
                            onChange={(e) => setSelectedState(e.target.value)}
                            className="dropdown"
                        >
                            <option value="">ESTADO</option>
                            {states?.map((state: any, index) => (
                                <option key={index} value={state}>
                                    {state}
                                </option>
                            ))}
                        </select>

                        <select
                            id="cliente"
                            value={selectedService}
                            onChange={(e) => setSelectedService(e.target.value)}
                            className="dropdown"
                        >
                            <option value="">SERVICIO</option>
                            {services?.map((service: any, index) => (
                                <option key={index} value={service}>
                                    {service}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="filter-buttons">
                    <button onClick={handleSearchClick} className="filter-search-button">BUSCAR</button>
                    <button onClick={handleClearFilters} className="clear-button">
                        BORRAR FILTROS
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FilterTicketModal;